// extracted by mini-css-extract-plugin
export default {"wrapper":"projects_wrapper__lHEY4","page-content":"projects_page-content__+yXm2","project":"projects_project__+9SnB","project-text":"projects_project-text__afScF"};